// Fiche du personnel « Titre · Nom · Prénoms · Fonction » (04/10/2026). L'adresse de connexion et le mot de
// passe initial sont calculés par be_config (POST /users/identifiant-propose, /users/store) ; ces fonctions ne
// servent qu'à pré-remplir la fiche et à afficher le récapitulatif.
export const CIVILITES = ['Dr', 'Pr', 'M.', 'Mme', 'Mlle', 'Me']

const sansAccents = texte => String(texte || '').normalize('NFD').replace(/[̀-ͯ]/g, '')

// Même règle que le serveur : « Éloïse-Marie Ama » → « eloise-marie ».
export function motDePasseInitial(prenoms) {
    const premier = String(prenoms || '').trim().split(/\s+/)[0] || ''
    return sansAccents(premier).toLowerCase().replace(/[^a-z0-9-]/g, '').replace(/^-+|-+$/g, '')
}

// Comptes créés avant la fiche : « Dr KAM Merlin » → Dr · KAM · Merlin ; les mots en majuscules forment le nom.
export function decouperNom(nomAffiche) {
    const mots = String(nomAffiche || '').trim().split(/\s+/).filter(Boolean)
    const civilite = mots.length > 1 && CIVILITES.indexOf(mots[0]) !== -1 ? mots.shift() : ''
    const estMajuscule = mot => mot.length > 1 && mot === mot.toLocaleUpperCase('fr-FR') && mot !== mot.toLocaleLowerCase('fr-FR')
    let fin = 0
    while (fin < mots.length - 1 && estMajuscule(mots[fin])) fin++
    if (fin === 0) fin = 1
    return { civilite, nom: mots.slice(0, fin).join(' '), prenoms: mots.slice(fin).join(' ') }
}

export function identiteDepuisCompte(compte) {
    const decoupe = decouperNom(compte && compte.name)
    return {
        civilite: (compte && compte.civilite) || decoupe.civilite,
        nom_famille: (compte && compte.nom) || decoupe.nom,
        prenoms: (compte && compte.prenoms) || decoupe.prenoms
    }
}

export function donneesCompte(personnel, { creation, domaine, rolesSecondaires }) {
    const donnees = {
        user_id: creation ? 0 : personnel.user_id,
        civilite: personnel.civilite || '',
        nom_famille: String(personnel.nom_famille || '').trim(),
        prenoms: String(personnel.prenoms || '').trim(),
        fonction: String(personnel.fonction || '').trim(),
        role_principal: personnel.role_principal ? personnel.role_principal.role_id : null
    }
    if (creation) donnees.domaine = domaine
    else Object.assign(donnees, { email: personnel.email, role_secondaires: rolesSecondaires || [] })
    return donnees
}
